import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/lib/api-client'
import type { Category } from '@/types'

export const categoriesQueryKey = ['categories'] as const

export function useCategories() {
  return useQuery({
    queryKey: categoriesQueryKey,
    queryFn: () => apiFetch<Category[]>('/categories'),
    staleTime: 60_000,
  })
}
